class ProductComplimentary extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const fresh = document.createElement('div');
        fresh.innerHTML = text;
        const newContent = fresh.querySelector('[data-api-content]');
        if (newContent) {
          this.innerHTML = newContent.innerHTML;
        }
        const loader = this.closest('[data-product-complimentary-loaded]');
        if (loader && newContent.innerHTML.trim() !== '') {
          // js-unloaded state hides the wrapper pre-render and
          // keeps it hidden for empty recommendations
          loader.classList.remove('js-unloaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

export {ProductComplimentary};
